/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint no-unused-vars : "off" */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-cycle */
import React, { useContext, useState, useRef } from 'react';
import { withRouter, Link } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import Modal from 'modules/common/components/Modal';
import ForgotPasswordContainerModal from 'modules/auth/containers/ForgotPasswordContainerModal';
import ResetPasswordContainerModal from 'modules/auth/containers/ResetPasswordContainerModal';
import PropTypes from 'prop-types';
import * as actions from 'modules/auth/actions';
import * as c from 'modules/auth/constants';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import ResetPasswordMobileContainerModal from './ResetPasswordMobileContainerModal';
import CmsContext from '../../../CmsContext';
import styles from './LogInModal.module.css';
import SignUpModalNew from './SignUpModalNew';

const form = {
  pin: '',
};

function PinModalContainer({
  mobileNo,
  forgotPasswordValidate,
  resendForgotPasswordValidate,
  isLoading,
  serviceList,
  isEmail,
}) {
  const replaced = mobileNo.slice(0, 2) + mobileNo.slice(2).replace(/.(?=...)/g, '*');
  const [formData, setFormData] = useState(form);
  const cmsContext = useContext(CmsContext);
  const LOGOS = cmsContext.findByType('LOGOS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const setModal = useContext(ModalContext);

  const handleResendOtp = (e) => {
    e.preventDefault();
    resendForgotPasswordValidate({ mobile_number: mobileNo });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    forgotPasswordValidate({ mobile_number: mobileNo, pin: formData.pin }, () => {
      e.preventDefault();
      setModal({
        isOpen: true,
        content: <ResetPasswordMobileContainerModal mobileNo={mobileNo} />,
        title: null,
        modalSize: 'modal-login',
        hideHeader: true,
        isCentered: true,
      });
    });
  };

  const handleOnClose = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOpenAuthModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <SignUpModalNew />,
      title: null,
      modalSize: 'modal-login',
      hideHeader: true,
      isCentered: true,
    });
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ForgotPasswordContainerModal />,
      title: null,
      modalSize: 'modal-lg',
      hideHeader: true,
      isCentered: true,
    });
  };

  return (
    <>
      <Modal.Body>
        <button type='button' className='close modal-close' onClick={handleOnClose}>
          <span aria-hidden='true'>&times;</span>
        </button>
        <div className={styles['login-container']}>
          <div className={styles['login-logo']}>
            <div>
              <img
                className='relative'
                src={
                  _.get(LOGOS, 'MAIN_LOGO.cdnUrl', '') ||
                  _.get(LOGOS, 'MAIN_LOGO', '') ||
                  defaultPhoto
                }
                // src="/ilgu/logo.svg"
                alt=''
                width={120}
                height={35}
              />
            </div>
            <div className={styles['login-title']}>
              <div className={styles['login-welcome']}>Welcome!</div>
              <div className={styles['login-description']}>Enter One-Time Password</div>
            </div>
          </div>
          <div className={styles['login-form-container']}>
            <div>
              <p className='form-sub-title'>
                Please enter the one-time Password (OTP) that we sent to {!isEmail && '+'}
                {replaced}.
              </p>
              <form>
                <div id='divOuter' className='form-group form-row'>
                  <div id='divInner'>
                    <input
                      id='partitioned'
                      name='pin'
                      autoFocus
                      autoComplete='off'
                      required
                      className='otp-value'
                      type='tel'
                      maxLength='6'
                      onChange={handleOnChange}
                    />
                    <div className='profile-under' />
                  </div>
                </div>
                <Link to='/' onClick={handleResendOtp} className='sign-up mt-3 d-block'>
                  Didn`t Receive OTP? <strong>Resend.</strong>
                </Link>

                {/* <Link
              to='/'
              onClick={handleResendOtp}
              className='sign-up mt-3 d-block'>
              Don’t have account yet? <strong>Sign up here.</strong>
            </Link> */}
              </form>
            </div>
          </div>
          <div className={styles['login-action-container']}>
            <button
              type='button'
              onClick={handleOnSubmit}
              disabled={isLoading}
              className='w-full inline-block text-center rounded-md bg-slate-800 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600 border border-slate-900'
            >
              {isLoading && <i className='fa fa-spin fa-spinner' />} Confirm OTP
            </button>

            <div
              className={styles['login-signup-here']}
              role='button'
              tabIndex='0'
              onClick={handleOpenAuthModal}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleOpenAuthModal();
                }
              }}
            >
              Don’t have account yet? <b>Sign up Here.</b>
            </div>
          </div>
        </div>
      </Modal.Body>
    </>
  );
}

PinModalContainer.propTypes = {
  mobileNo: PropTypes.string.isRequired,
  forgotPasswordValidate: PropTypes.instanceOf(Function).isRequired,
  resendForgotPasswordValidate: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isEmail: PropTypes.bool.isRequired,
  serviceList: PropTypes.instanceOf(Array).isRequired,
};

const removeENews = (res) => {
  const newArr = res.filter((d) => {
    return d.attributes.name !== 'E-News' && d.attributes.name !== 'E-Wallet';
  });
  return newArr;
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, 'loading', []).indexOf(c.FORGOT_PASSWORD) > -1,
  serviceList: removeENews(_.get(api, 'SERVICES/get_services', []).list || []),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PinModalContainer);
